import { Box, Divider, Link, Stack, Typography } from "@mui/material";
import React from "react";
import bgFooterImg from "../../assets/img/footer-back.jpg";
import CondFooterImg from "../../assets/img/footer-cond-1.png";
import Cond3FooterImg from "../../assets/img/footer-cond-3.png";
import DiscordFooterImg from "../../assets/img/footer-discord.png";

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        position: "relative",
        color: "white",
        backgroundImage: `url(${bgFooterImg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        zIndex: 10,
        py: 2,
      }}
    >
      <Box sx={{ px: { xs: 2, sm: 3, md: 4 } }}>
        {/* Top Icons */}
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          gap={2}
          mb={1}
          flexWrap="wrap"
        >
          <Box
            component="a"
            href="https://discord.gg/3qFdjNkxQX"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ width: 36 }}
          >
            <Box
              component="img"
              src={DiscordFooterImg}
              alt="Discord"
              sx={{ width: "100%", display: "block" }}
            />
          </Box>

          <Box
            component="a"
            href="https://www.xtremetop100.com/conquer-online"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ width: 36 }}
          >
            <Box
              component="img"
              src="https://www.xtremeTop100.com/votenew.jpg"
              alt="Vote"
              sx={{ width: "100%", display: "block" }}
            />
          </Box>
        </Box>

        {/* Copyright */}
        <Typography
          align="center"
          sx={{
            fontSize: 11,
            color: "#a0a0a0",
            fontWeight: 400,
            mb: 0.5,
          }}
        >
          © 2025 DarkNovaConquer
        </Typography>

        {/* Policy Links */}
        <Stack
          direction="row"
          spacing={2}
          justifyContent="center"
          alignItems="center"
          mb={1}
        >
          {["Terms", "Privacy", "Refund"].map((label) => (
            <Link
              key={label}
              href={
      label === "Refund"
        ? "/refund-policy"
        : "#"
    }
              sx={{
                fontSize: 11,
                fontWeight: 500,
                color: "white",
                textDecoration: "none",
                "&:hover": {
                  color: "#fff589",
                },
              }}
            >
              {label}
            </Link>
          ))}
        </Stack>

        {/* Payment / Dev Icons */}
        <Stack
          direction="row"
          spacing={2}
          justifyContent="center"
          alignItems="center"
          mb={1}
        >
          <Box component="a" href="#" target="_blank" rel="noopener noreferrer">
            <Box
              component="img"
              src={CondFooterImg}
              alt="Payment"
              sx={{ height: 20 }}
            />
          </Box>

          <Box display="flex" alignItems="center" gap={1}>
            <Box
              component="img"
              src={Cond3FooterImg}
              alt="Developer"
              sx={{ height: 20 }}
            />
            <Typography sx={{ fontSize: 10, lineHeight: 1.1 }}>
              by DarkDevelopment
            </Typography>
          </Box>
        </Stack>

        <Divider sx={{ borderColor: "#333", my: 1 }} />

        {/* Disclaimer */}
        <Typography
          align="center"
          color="#666"
          sx={{
            fontSize: 10,
            maxWidth: 600,
            mx: "auto",
            lineHeight: 1.3,
          }}
        >
          DarkNovaConquer is a Classic Conquer emulator. Use of this service is
          for informational purposes only. The original game is available from
          TQ Digital on their official servers.
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
